/**
 * Semantic color constants for use in core.
 * Values aligned with design system (ds_legacy/materials/colors).
 */
export const ACCENT_COLOR = "#FCEC7D";
export const ERROR_COLOR = "#E13023";
export const SUCCESS_COLOR = "#43A047";
